import { type PropsWithChildren } from "react";

import Valkyrie, { viArrowUp } from "@sippy-platform/valkyrie";

import { type SxProps, Typography } from "@mui/material";

export default function TableHeading({
  id,
  setFilter,
  order,
  orderBy,
  align,
  sx,
  children,
}: PropsWithChildren<{
  id?: string;
  order?: "asc" | "desc";
  setFilter?: (key: string, value: string) => void;
  orderBy?: string;
  align?: "right";
  sx?: SxProps;
}>) {
  return (
    <Typography
      sx={[
        {
          fontWeight: 600,
          fontSize: 14,
          lineHeight: 1.125,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: align === "right" ? "flex-end" : "flex-start",
          gap: 0.5,
          textWrap: "nowrap",
        },
        {
          cursor: id ? "pointer" : undefined,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={
        id && setFilter
          ? () => {
              if (orderBy === id) {
                setFilter("order", order === "asc" ? "desc" : "asc");
              } else {
                setFilter("orderBy", id);
                setFilter("order", "desc");
              }
            }
          : undefined
      }
    >
      {children} {id && orderBy === id && <Valkyrie icon={viArrowUp} rotate={order === "asc" ? 180 : 0} />}
    </Typography>
  );
}
